module.exports = __webpack_public_path__ + "officialStatic/img/index-solution-bg.8423361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-solution-bg.png
// module id = 7QOj
// module chunks = 0